'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * 艺品预选组件
                    * Created by zfc on 2016/8/4.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _GoeasyRadio = require('../GoeasyInputField/GoeasyRadio');

var _GoeasyRadio2 = _interopRequireDefault(_GoeasyRadio);

var _reactRouter = require('react-router');

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactRadio = require('react-radio');

var _reactRadio2 = _interopRequireDefault(_reactRadio);

var _SubmitBtn = require('../SubmitBtn/SubmitBtn');

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

var _reactCollapse = require('react-collapse');

var _reactCollapse2 = _interopRequireDefault(_reactCollapse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreSelectionProductComponent = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PreSelectionProductComponent, _Component);

  function PreSelectionProductComponent() {
    (0, _classCallCheck3.default)(this, PreSelectionProductComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PreSelectionProductComponent).call(this));

    _this.state = {
      isPolicyOpened: false,
      isServiceOpened: false,
      isPackagingOpened: false,
      isCustomOpened: false,
      closeHover: false
    };
    return _this;
  }

  (0, _createClass3.default)(PreSelectionProductComponent, [{
    key: 'onAllModalOpen',
    value: function onAllModalOpen(productId) {
      var onDetailShow = this.props.onDetailShow;

      if (onDetailShow) {
        onDetailShow(productId);
      }
    }
  }, {
    key: 'onAllModalHide',
    value: function onAllModalHide() {
      var onDetailModalClose = this.props.onDetailModalClose;

      if (onDetailModalClose) {
        onDetailModalClose();
        this.setState({
          isPolicyOpened: false,
          isServiceOpened: false,
          isPackagingOpened: false,
          isCustomOpened: false
        });
      }
    }
  }, {
    key: 'onPolicyChange',
    value: function onPolicyChange(product, newValue) {
      var policyChange = this.props.policyChange;

      if (policyChange) {
        policyChange(product, newValue);
      }
    }
  }, {
    key: 'onNumberChange',
    value: function onNumberChange(product, number, type) {
      var numberChange = this.props.numberChange;

      var currentNumber = parseInt(number, 10);
      if (!isNaN(currentNumber)) {
        if (type === 'add') {
          ++currentNumber;
        } else if (type === 'sub' && currentNumber > 1) {
          --currentNumber;
        }
        if (currentNumber > 0 && currentNumber.toString() !== number.toString()) {
          numberChange(product, currentNumber.toString());
        }
      }
    }
  }, {
    key: 'onDetailShow',
    value: function onDetailShow(value) {
      var _state = this.state;
      var isPolicyOpened = _state.isPolicyOpened;
      var isServiceOpened = _state.isServiceOpened;
      var isPackagingOpened = _state.isPackagingOpened;
      var isCustomOpened = _state.isCustomOpened;
      /*  if (value === 'policy') {
       this.setState({
       isPolicyOpened: !isPolicyOpened
       });
       }*/

      switch (value) {
        case 'policy':
          this.setState({
            isPolicyOpened: !isPolicyOpened
          });
          break;
        case 'service':
          this.setState({
            isServiceOpened: !isServiceOpened
          });
          break;
        case 'packaging':
          this.setState({
            isPackagingOpened: !isPackagingOpened
          });
          break;
        case 'custom':
          this.setState({
            isCustomOpened: !isCustomOpened
          });
          break;
        default:
      }
    }
  }, {
    key: 'removeSelf',
    value: function removeSelf(product) {
      var onRemoveItem = this.props.onRemoveItem;

      if (onRemoveItem) {
        onRemoveItem(product);
      }
    }
  }, {
    key: 'chooseOrNot',
    value: function chooseOrNot(product) {
      var onChooseItem = this.props.onChooseItem;

      if (onChooseItem) {
        onChooseItem(product);
      }
    }
  }, {
    key: 'closeImgMouseOver',
    value: function closeImgMouseOver() {
      this.setState({
        closeHover: true
      });
    }
  }, {
    key: 'closeImgMouseLeave',
    value: function closeImgMouseLeave() {
      this.setState({
        closeHover: false
      });
    }
  }, {
    key: 'isEmptyObject',
    value: function isEmptyObject(element) {
      var tvar = void 0;
      for (tvar in element) {
        if (tvar) {
          return !1;
        }
      }
      return !0;
    }
  }, {
    key: 'analysisProductData',
    value: function analysisProductData() {
      var _this2 = this;

      var data = this.props.data;

      var groupInfo = [];
      var styles = require('./PreSelectionProductComponent.scss');
      if (data instanceof Array) {
        data.forEach(function (singleProduct) {
          var index = groupInfo.findIndex(function (info) {
            return info.shop === singleProduct.shop;
          });
          if (index < 0) {
            groupInfo.push({
              shop: singleProduct.shop,
              items: [(0, _extends3.default)({}, singleProduct)]
            });
          } else {
            groupInfo[index].items.push((0, _extends3.default)({}, singleProduct));
          }
        });
      }
      return groupInfo.map(function (info, groupIndex) {
        var productsDetailShow = info.items.map(function (product, outIndex) {
          var buyPrice = 0;
          if (!isNaN(parseFloat(product.buyPrice, 10))) {
            buyPrice = parseFloat(product.buyPrice, 10).toFixed(2);
          }
          return _react2.default.createElement(
            'tr',
            { key: outIndex },
            _react2.default.createElement(
              'td',
              { className: styles.item },
              _react2.default.createElement('img', { onClick: function onClick() {
                  return _this2.chooseOrNot(product);
                },
                src: product.selected === '1' ? 'http://tupian.goeasy.cn:9999/yipinwang/per_center/radio_hover.png' : 'http://tupian.goeasy.cn:9999/yipinwang/per_center/radio.png',
                alt: '', className: styles.operateImg })
            ),
            _react2.default.createElement(
              'td',
              { className: styles.item },
              _react2.default.createElement(
                _reactRouter.Link,
                {
                  to: (product.isCustomProduct && product.isCustomProduct === '1' ? '/customproduct/' : '/product/') + product.productId,
                  target: '_blank' },
                _react2.default.createElement('img', {
                  className: styles.productImg, src: product.img, alt: '' })
              )
            ),
            _react2.default.createElement(
              'td',
              { className: styles.item },
              product.name,
              product.size
            ),
            _react2.default.createElement(
              'td',
              { className: styles.item },
              buyPrice
            ),
            _react2.default.createElement(
              'td',
              { className: styles.item },
              _react2.default.createElement(
                'div',
                { className: styles.numberContainer },
                _react2.default.createElement(
                  'div',
                  { className: styles.numberItem, onClick: function onClick() {
                      return _this2.onNumberChange(product, product.number, 'sub');
                    } },
                  _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/third/minus.png' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.numberShow },
                  product.number
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.numberItem, onClick: function onClick() {
                      return _this2.onNumberChange(product, product.number, 'add');
                    } },
                  _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/third/plus.png' })
                )
              ),
              _react2.default.createElement('div', { className: 'clear' })
            ),
            _react2.default.createElement(
              'td',
              { className: styles.item },
              _react2.default.createElement(
                'span',
                null,
                product.sumMoney
              )
            ),
            _react2.default.createElement(
              'td',
              { className: styles.item },
              _react2.default.createElement(
                'span',
                { onClick: function onClick() {
                    return _this2.onAllModalOpen(product.id);
                  },
                  className: styles.button },
                '详情查询'
              )
            ),
            _react2.default.createElement(
              'td',
              { className: styles.item },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement('img', (0, _defineProperty3.default)({ onClick: function onClick() {
                    return _this2.removeSelf(product);
                  },
                  className: styles.editAndCloseImg,
                  src: 'http://tupian.goeasy.cn:9999/yipinwang/per_center/delete.png',
                  alt: ''
                }, 'className', styles.operateImg))
              )
            )
          );
        });
        return _react2.default.createElement(
          'div',
          { key: groupIndex },
          info.shop && info.shop !== '' ? _react2.default.createElement(
            'div',
            { className: styles.shopName },
            info.shop
          ) : '',
          _react2.default.createElement(
            'table',
            { className: styles.component },
            _react2.default.createElement(
              'colgroup',
              null,
              _react2.default.createElement('col', { width: '8%' }),
              _react2.default.createElement('col', { width: '12%' }),
              _react2.default.createElement('col', { width: '18%' }),
              _react2.default.createElement('col', { width: '9%' }),
              _react2.default.createElement('col', { width: '12%' }),
              _react2.default.createElement('col', { width: '10%' }),
              _react2.default.createElement('col', { width: '12%' }),
              _react2.default.createElement('col', { width: '7%' })
            ),
            _react2.default.createElement('thead', null),
            _react2.default.createElement(
              'tbody',
              null,
              productsDetailShow
            )
          )
        );
      });
    }
  }, {
    key: 'analysisDetailModal',
    value: function analysisDetailModal() {
      var _this3 = this;

      var _props = this.props;
      var modalProductId = _props.modalProductId;
      var detailData = _props.detailData;
      var data = _props.data;
      var detailModalOpened = _props.detailModalOpened;

      var styles = require('./PreSelectionProductComponent.scss');
      var _state2 = this.state;
      var isPolicyOpened = _state2.isPolicyOpened;
      var isServiceOpened = _state2.isServiceOpened;
      var isPackagingOpened = _state2.isPackagingOpened;
      var isCustomOpened = _state2.isCustomOpened;
      var closeHover = _state2.closeHover;

      var allCustomStyle = {
        content: {
          background: '#ffffff',
          overflow: 'hidden',
          outline: 'none',
          zIndex: 9999,
          border: '0',
          borderRadius: '30px',
          boxShadow: '3px 2px 20px',
          bottom: 'auto',
          minHeight: '10rem',
          left: '50%',
          padding: '2rem 0px',
          position: 'fixed',
          right: 'auto',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          minWidth: '20rem',
          width: '80rem',
          maxWidth: '80rem'
        }
      };
      var policyModalDiv = '';
      var currentProduct = {};
      data.forEach(function (product) {
        if (product.id === modalProductId) {
          currentProduct = (0, _extends3.default)({}, product);
          // product.policyList = [{value: '01', label: '满200减50，满10000减500'}, {value: '02', label: '满5件8折'}];
          if (product.policyList instanceof Array) {
            policyModalDiv = product.policyList.map(function (policyInfo, index) {
              return _react2.default.createElement(_GoeasyRadio2.default, { key: index, Id: policyInfo.value, currentData: policyInfo });
            });
          }
        }
      });
      var price = 0;
      if (!this.isEmptyObject(currentProduct)) {
        if (!isNaN(parseFloat(currentProduct.price, 10))) {
          price = parseFloat(currentProduct.price, 10).toFixed(2);
        }
      }
      var packagingData = detailData.packagingData;
      var serviceData = detailData.serviceData;
      var customData = detailData.customData;

      return _react2.default.createElement(
        _reactModal2.default,
        { style: allCustomStyle, isOpen: detailModalOpened },
        _react2.default.createElement(
          'div',
          { className: styles.modalTitle },
          _react2.default.createElement('img', { className: closeHover ? styles.xuzhuan : styles.xuzhuan_a, onMouseOver: this.closeImgMouseOver.bind(this),
            onMouseLeave: this.closeImgMouseLeave.bind(this), onClick: function onClick() {
              return _this3.onAllModalHide();
            },
            src: 'http://tupian.goeasy.cn:9999/yipinwang/third/close.png', alt: '',
            width: '100%' })
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'div',
          { style: { padding: '10px 20px 0px' } },
          _react2.default.createElement(
            'div',
            { className: styles.pageTopTitle, style: { marginTop: 10 } },
            '艺品预选'
          ),
          _react2.default.createElement('div', { className: styles.linka }),
          _react2.default.createElement('div', { className: styles.shortLine }),
          _react2.default.createElement(
            'table',
            { className: styles.modalComponent },
            _react2.default.createElement(
              'colgroup',
              null,
              _react2.default.createElement('col', { width: '25%' }),
              _react2.default.createElement('col', { width: '25%' }),
              _react2.default.createElement('col', { width: '25%' }),
              _react2.default.createElement('col', { width: '25%' })
            ),
            _react2.default.createElement(
              'thead',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'th',
                  null,
                  '艺品'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  '数量'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  '单价'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  '金额'
                )
              )
            ),
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { className: styles.item },
                  currentProduct.name,
                  currentProduct.size
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.item },
                  currentProduct.number
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.item },
                  price
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.item },
                  currentProduct.money
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.modalContent },
          _react2.default.createElement(
            'div',
            { className: styles.detailContent },
            _react2.default.createElement(
              'div',
              { style: { float: 'left' }, className: styles.pageTopTitle },
              '优惠'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.pateTopTail },
              _react2.default.createElement('img', { onClick: function onClick() {
                  return _this3.onDetailShow('policy');
                },
                className: isPolicyOpened ? styles.zhuan : styles.zhuan_a,
                src: 'http://tupian.goeasy.cn:9999/yipinwang/third/sletxia.png' })
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement('div', { className: styles.linka }),
            _react2.default.createElement('div', { className: styles.shortLine }),
            _react2.default.createElement(
              _reactCollapse2.default,
              { isOpened: isPolicyOpened },

              //  src="http://tupian.goeasy.cn:9999/yipinwang/home/icon_top.jpg"
              policyModalDiv instanceof Array && policyModalDiv.length > 0 ? _react2.default.createElement(
                _reactRadio2.default,
                { ref: 'policyChosenAll', name: 'policyChosenAll_' + currentProduct.productId,
                  value: currentProduct.policy, style: { padding: 30 },
                  onChange: function onChange(val) {
                    return _this3.onPolicyChange(currentProduct, val);
                  } },
                policyModalDiv
              ) : _react2.default.createElement(
                'div',
                { style: { margin: '30px 0px 0px 100px', fontSize: '14px', height: 50, width: '100%' } },
                '无优惠'
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { float: 'left' }, className: styles.pageTopTitle },
              '服务'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.pateTopTail },
              _react2.default.createElement('img', { onClick: function onClick() {
                  return _this3.onDetailShow('service');
                },
                className: isServiceOpened ? styles.zhuan : styles.zhuan_a,
                src: 'http://tupian.goeasy.cn:9999/yipinwang/third/sletxia.png' })
            ),
            serviceData instanceof Array ? _react2.default.createElement(
              'div',
              { className: styles.pageTopMoney },
              _react2.default.createElement(
                'span',
                null,
                '金额：'
              ),
              _react2.default.createElement(
                'span',
                null,
                serviceData[0].money
              )
            ) : '',
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement('div', { className: styles.linka }),
            _react2.default.createElement('div', { className: styles.shortLine }),
            _react2.default.createElement(
              _reactCollapse2.default,
              { isOpened: isServiceOpened },
              _react2.default.createElement(
                'table',
                { className: styles.modalTableComponent },
                _react2.default.createElement(
                  'colgroup',
                  null,
                  _react2.default.createElement('col', { width: '50%' }),
                  _react2.default.createElement('col', { width: '50%' })
                ),
                _react2.default.createElement(
                  'thead',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'th',
                      null,
                      '项目'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      '单价'
                    )
                  )
                ),
                _react2.default.createElement(
                  'tbody',
                  null,
                  serviceData instanceof Array ? serviceData.map(function (serviceInfo, index) {
                    return _react2.default.createElement(
                      'tr',
                      { key: index, className: styles.item },
                      _react2.default.createElement(
                        'td',
                        null,
                        serviceInfo.project
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        serviceInfo.price
                      )
                    );
                  }) : ''
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { float: 'left' }, className: styles.pageTopTitle },
              '包装'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.pateTopTail },
              _react2.default.createElement('img', { onClick: function onClick() {
                  return _this3.onDetailShow('packaging');
                },
                className: isPackagingOpened ? styles.zhuan : styles.zhuan_a,
                src: 'http://tupian.goeasy.cn:9999/yipinwang/third/sletxia.png' })
            ),
            packagingData instanceof Array ? _react2.default.createElement(
              'div',
              { className: styles.pageTopMoney },
              _react2.default.createElement(
                'span',
                null,
                '金额：'
              ),
              _react2.default.createElement(
                'span',
                null,
                packagingData[0].money
              )
            ) : '',
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement('div', { className: styles.linka }),
            _react2.default.createElement('div', { className: styles.shortLine }),
            _react2.default.createElement(
              _reactCollapse2.default,
              { isOpened: isPackagingOpened },
              _react2.default.createElement(
                'table',
                { className: styles.modalTableComponent },
                _react2.default.createElement(
                  'colgroup',
                  null,
                  _react2.default.createElement('col', { width: '25%' }),
                  _react2.default.createElement('col', { width: '25%' }),
                  _react2.default.createElement('col', { width: '25%' }),
                  _react2.default.createElement('col', { width: '25%' })
                ),
                _react2.default.createElement(
                  'thead',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement('th', null),
                    _react2.default.createElement(
                      'th',
                      null,
                      '项目'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      '内容'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      '单价'
                    )
                  )
                ),
                _react2.default.createElement(
                  'tbody',
                  null,
                  packagingData instanceof Array ? packagingData.map(function (packagingInfo, index) {
                    return _react2.default.createElement(
                      'tr',
                      { key: index, className: styles.item },
                      _react2.default.createElement(
                        'td',
                        null,
                        packagingInfo.img ? _react2.default.createElement('img', { className: styles.dingzImg, src: packagingInfo.img }) : ''
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        packagingInfo.project
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        packagingInfo.content
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        packagingInfo.price
                      )
                    );
                  }) : ''
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { float: 'left' }, className: styles.pageTopTitle },
              '定制'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.pateTopTail },
              _react2.default.createElement('img', { onClick: function onClick() {
                  return _this3.onDetailShow('custom');
                },
                className: isCustomOpened ? styles.zhuan : styles.zhuan_a,
                src: 'http://tupian.goeasy.cn:9999/yipinwang/third/sletxia.png' })
            ),
            customData instanceof Array ? _react2.default.createElement(
              'div',
              { className: styles.pageTopMoney },
              _react2.default.createElement(
                'span',
                null,
                '金额：'
              ),
              _react2.default.createElement(
                'span',
                null,
                customData[0].money
              )
            ) : '',
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement('div', { className: styles.linka }),
            _react2.default.createElement('div', { className: styles.shortLine }),
            _react2.default.createElement(
              _reactCollapse2.default,
              { isOpened: isCustomOpened },
              _react2.default.createElement(
                'table',
                { className: styles.modalTableComponent },
                _react2.default.createElement(
                  'colgroup',
                  null,
                  _react2.default.createElement('col', { width: '25%' }),
                  _react2.default.createElement('col', { width: '25%' }),
                  _react2.default.createElement('col', { width: '25%' }),
                  _react2.default.createElement('col', { width: '25%' })
                ),
                _react2.default.createElement(
                  'thead',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement('th', null),
                    _react2.default.createElement(
                      'th',
                      null,
                      '项目'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      '内容'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      '单价'
                    )
                  )
                ),
                _react2.default.createElement(
                  'tbody',
                  null,
                  customData instanceof Array ? customData.map(function (customInfo, index) {
                    return _react2.default.createElement(
                      'tr',
                      { key: index, className: styles.item },
                      _react2.default.createElement(
                        'td',
                        null,
                        _react2.default.createElement('img', { className: styles.dingzImg, src: customInfo.img })
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        customInfo.project
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        customInfo.content
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        customInfo.price
                      )
                    );
                  }) : ''
                )
              )
            ),
            _react2.default.createElement('div', { style: { width: '100%', height: 100 } })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.modalContent },
          _react2.default.createElement('div', { className: styles.linka, style: { marginTop: 20 } }),
          _react2.default.createElement(
            'div',
            { className: styles.detailContent },
            _react2.default.createElement(
              'table',
              { className: styles.modalTableComponent },
              _react2.default.createElement(
                'colgroup',
                null,
                _react2.default.createElement('col', { width: '25%' }),
                _react2.default.createElement('col', { width: '25%' }),
                _react2.default.createElement('col', { width: '25%' }),
                _react2.default.createElement('col', { width: '25%' })
              ),
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    '艺品金额'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    '购买金额'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    '优惠金额'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    '结算金额'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { className: styles.item },
                    currentProduct.money
                  ),
                  _react2.default.createElement(
                    'td',
                    { className: styles.item },
                    currentProduct.buyMoney
                  ),
                  _react2.default.createElement(
                    'td',
                    { className: styles.item },
                    currentProduct.discount
                  ),
                  _react2.default.createElement(
                    'td',
                    { className: styles.item },
                    currentProduct.sumMoney
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_SubmitBtn2.default, { btnClick: function btnClick() {
            return _this3.onAllModalHide();
          }, text: '关闭' })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./PreSelectionProductComponent.scss');
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'table',
          { className: styles.component },
          _react2.default.createElement(
            'colgroup',
            null,
            _react2.default.createElement('col', { width: '8%' }),
            _react2.default.createElement('col', { width: '12%' }),
            _react2.default.createElement('col', { width: '18%' }),
            _react2.default.createElement('col', { width: '9%' }),
            _react2.default.createElement('col', { width: '12%' }),
            _react2.default.createElement('col', { width: '10%' }),
            _react2.default.createElement('col', { width: '12%' }),
            _react2.default.createElement('col', { width: '7%' })
          ),
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                '选择'
              ),
              _react2.default.createElement(
                'th',
                null,
                '图片'
              ),
              _react2.default.createElement(
                'th',
                null,
                '艺品'
              ),
              _react2.default.createElement(
                'th',
                null,
                '单价'
              ),
              _react2.default.createElement(
                'th',
                null,
                '数量'
              ),
              _react2.default.createElement(
                'th',
                null,
                '金额'
              ),
              _react2.default.createElement(
                'th',
                null,
                ' '
              ),
              _react2.default.createElement(
                'th',
                null,
                ' '
              )
            )
          )
        ),
        this.analysisProductData(),
        this.analysisDetailModal()
      );
    }
  }]);
  return PreSelectionProductComponent;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.array.isRequired,
  detailData: _react.PropTypes.object,
  modalProductId: _react.PropTypes.string,
  detailModalOpened: _react.PropTypes.bool,
  onDetailShow: _react.PropTypes.func,
  onDetailModalClose: _react.PropTypes.func,
  onChooseItem: _react.PropTypes.func,
  policyChange: _react.PropTypes.func,
  numberChange: _react.PropTypes.func,
  onRemoveItem: _react.PropTypes.func
}, _temp);
exports.default = PreSelectionProductComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/PreSelectionProductComponent/PreSelectionProductComponent.js
 ** module id = 1403
 ** module chunks = 0
 **/